import CircleRoundedIcon from '@mui/icons-material/CircleRounded';
import { ListItemButton } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const ContactListItemRoot = styled(ListItemButton)(({ theme }) => ({
  '&&': {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
  },
  '&&:hover': { backgroundColor: theme.palette.background.default },
  '&&.Mui-selected, &&.Mui-selected:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.5),
    color: theme.palette.common.white,
  },
}));

export const UnreadIndicator = styled(CircleRoundedIcon)(({ theme }) => ({
  width: 15,
  height: 15,
  marginRight: theme.spacing(1),
}));
